import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import Tooltip from './ToolTip';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();

  const allThemes = [
    { value: 'light' as const, icon: Sun, label: 'Light' },
    { value: 'dark' as const, icon: Moon, label: 'Dark' },
    { value: 'system' as const, icon: Monitor, label: 'System' },
  ];

  const getCurrentTheme = () => {
    return allThemes.find(t => t.value === theme) || allThemes[2];
  };

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('light');
    } else {
      setTheme('light');
    }
  };

  const currentTheme = getCurrentTheme();
  const CurrentIcon = currentTheme.icon;

  return (
    <Tooltip message={`Current: ${currentTheme.label}. Click to switch theme.`}>
       <button
      onClick={cycleTheme}
      className={`
        p-2 rounded-md transition-all duration-200 bg-gray-100 dark:bg-gray-800
        text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white
        ${className}
      `}
      // title={`Current: ${currentTheme.label}. Click to switch theme.`}
    >
      <CurrentIcon className="w-4 h-4" />
    </button>
    </Tooltip>
   
  );
};

export default ThemeToggle;
